import { BankerRepoImpl } from "domain/repository/Banker/BankerRepoImpl";
import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { ParameterDetailRepoImpl } from "domain/repository/parameter/ParameterDetailRepoImpl";
import { RefundRepoImpl } from "domain/repository/Refund/RefundRepoImpl";
import { useRefundTracked } from "presentation/store/Refund/RefundProvider";
import { RefundVM } from "presentation/viewModel/Refund/RefundVM";
import { useMemo } from "react";

export const useRefundVM = () => {
    const [, setRefundState] = useRefundTracked();
    const refundVM = useMemo(() =>
        RefundVM({
            dispatch: [setRefundState],
            repo: RefundRepoImpl(),
            companyRepo: CompanyRepoImpl(),
            bankerRepo: BankerRepoImpl(),
            parameterDetailRepo: ParameterDetailRepoImpl(),
        }), [setRefundState])

    return refundVM
}